module.exports = __webpack_public_path__ + "static/media/phoneIcon.b8846927.svg";